import DateInput from "../../../forms/Inputs/Date/Date";
import Chosen from '../../../forms/Inputs/Select/Chosen'
import moment from "moment/moment";
import RentalTabs from "../tabs/tabs"
import RentalAccordion from "../accordion/RentalAccordion";
import {gsap} from "gsap";

const RentalDate = {
    init(animate) {
        this.el = $('[module="rental"][section="date"]');
        if (!this.el.length) return;

        this.form = this.el.find('[form="date"]');
        this.dateFrom = this.el.find('[name="date_from"]');
        this.timeFrom = this.el.find('[name="time_from"]');
        this.dateTo = this.el.find('[name="date_to"]');
        this.timeTo = this.el.find('[name="time_to"]');
        this.numberMonths = this.el.find('[name="number_months"]');
        this.rentalType = this.el.find('[name="rental_type"]');
        this.rentalLengthDays = this.el.find('.rentalLength .days');
        this.rentalLengthMonths = this.el.find('.rentalLength .months');
        this.takingLocationDropdown = this.el.find('[name="taking_location_dropdown"]');
        this.takingLocation = this.el.find('[name="taking_location"]');
        this.takingLocationDescription = this.el.find('[name="taking_location_description"]');
        this.returnLocationDropdown = this.el.find('[name="return_location_dropdown"]');
        this.returnLocation = this.el.find('[name="return_location"]');
		this.returnLocationDescription = this.el.find('[name="return_location_description"]');
        this.nextBtn = this.el.find('.dateSelection button.next.date');
        this.nextBtnHome = this.el.find('.dateSelection button.next.home');
        this.tabRentalLength = RentalTabs.el.find('.date [key="rental_length"]');
        this.accordionDates = RentalAccordion.el.length && RentalAccordion.headers.filter('[key="date"]').find('.dates');
        this.clearTakingBtn = this.el.find('[name="clear_taking"]');
        this.clearReturnBtn = this.el.find('[name="clear_return"]');

		this.titleDateReturn = this.el.find('[name="title_date_return"]');
        this.titleMonthLength = this.el.find('[name="title_month_length"]');

		this.tabs = this.el.find('nav li');

        this.selectedVehicle = {};
        const vehicleId = this.el.find('input[name="vehicle"]').val();
        if (vehicleId) this.selectedVehicle = {'vehicle': vehicleId};

		Chosen.init(this.form);

        this.bind();
		this.dateGuard();
		if (animate) this.animate();
    },

	animate() {
		gsap.timeline()
			.from(this.el.find('[block="strip"] main'), {opacity: 0, stagger: 0.15, y: 100, duration: 0.7, clearProps:true}, 0)
			.from(this.el.find('[block="strip"] nav li'), {opacity: 0, stagger: 0.15, y: 100, duration: 0.7, clearProps:true}, 0.2)
			.from(this.el.find('[block="strip"] .banner'), {opacity: 0, stagger: 0.15, y: 100, duration: 0.7, clearProps:true}, 0.4)
	},

    bind() {
		DateInput.bind(this.form);

        this.nextBtn.on('click', () => this.create(this.selectedVehicle, 1));
        this.nextBtnHome.on('click', () => this.createAsync());
		this.dateFrom.on('change', (event) => this.updateForm(event));
		this.timeFrom.on('change', (event) => this.updateForm(event));
		this.dateTo.on('change', (event) => this.updateForm(event));
		this.timeTo.on('change', (event) => this.updateForm(event));
		this.takingLocation.on('change', (event) => this.updateForm(event));
		this.returnLocation.on('change', (event) => this.updateForm(event));
		this.takingLocationDropdown.on('change', () => this.takingLocationDropdownChange());
		this.returnLocationDropdown.on('change', () => this.returnLocationDropdownChange());
		this.numberMonths.on('change', () => this.changeNumberMonths());
		this.clearTakingBtn.on('click', () => this.clearTaking());
		this.clearReturnBtn.on('click', () => this.clearReturn());

        this.tabs.click((evt) => {
            const tab = $(evt.currentTarget);
            tab.addClass('active').siblings().removeClass('active');

			this.rentalType.val(tab.attr('length'));
            this[tab.attr('length')]();
			this.updateForm()
        })
    },

	dateGuard() {
		if (this.rentalType.val() === 'short') {
			this.dateFrom.closest('.input').attr('from', moment().add(1, 'day').format('DD.MM.YYYY'))
			this.dateTo.closest('.input').attr('from', moment(this.dateFrom.val(), 'DD.MM.YYYY').add(1, 'day').format('DD.MM.YYYY'))
			this.dateTo.closest('.input').attr('to', moment(this.dateFrom.val(), 'DD.MM.YYYY').add(28, 'days').format('DD.MM.YYYY'))
			this.dateTo.css({pointerEvents: ''});

			if (moment(this.dateTo.val(), 'DD.MM.YYYY').diff(moment(this.dateFrom.val(), 'DD.MM.YYYY'), 'days', true) < 1) {
				this.dateTo.val(moment(this.dateFrom.val(), 'DD.MM.YYYY').add(1, 'day').format('DD.MM.YYYY'));
			}

			if (moment(this.dateTo.val(), 'DD.MM.YYYY').diff(moment(this.dateFrom.val(), 'DD.MM.YYYY'), 'month', true) > 1) {
				this.dateTo.val(moment(this.dateFrom.val(), 'DD.MM.YYYY').add(28, 'days').format('DD.MM.YYYY'));
			}

			this.setRentalLength()
		}

		if (this.rentalType.val() === 'long') {
			this.dateTo.val(moment(this.dateFrom.val(), 'DD.MM.YYYY').add(this.numberMonths.val(), 'month').format('DD.MM.YYYY'));
			this.dateTo.css({pointerEvents: ''});
		}

		if (this.rentalType.val() === 'week') {
			this.dateFrom.val(this.findNextWeekend());
			this.dateTo.closest('.input').attr('from', moment(this.dateFrom.val(), 'DD.MM.YYYY').add(1, 'day').format('DD.MM.YYYY'))
			this.dateTo.closest('.input').attr('to', moment(this.dateFrom.val(), 'DD.MM.YYYY').add(4, 'day').format('DD.MM.YYYY'))
			this.dateTo.val(moment(this.dateFrom.val(), 'DD.MM.YYYY').add(4, 'days').format('DD.MM.YYYY'));
			this.dateTo.css({pointerEvents: 'none'});

			this.setRentalLength()
		}

		RentalAccordion.el.length && this.accordionDates.html(
			moment(this.dateFrom.val(), 'DD.MM.YYYY').format('DD.MM')
			+ ' - ' +
			moment(this.dateTo.val(), 'DD.MM.YYYY').format('DD.MM')
		)
	},

	findNextWeekend() {
		let today = moment();
		let dayOfWeek = today.add(1, 'day').day();

		let daysUntilFriday;
		if (dayOfWeek <= 5) {
			daysUntilFriday = 5 - dayOfWeek;
		} else {
			daysUntilFriday = 12 - dayOfWeek;
		}

		let nearestFriday = today.add(daysUntilFriday, 'days');
		return nearestFriday.format('DD.MM.YYYY');
	},

	setRentalLength() {
		let timeFrom = moment(this.timeFrom.val(), 'HH:mm');
		let timeTo = moment(this.timeTo.val(), 'HH:mm');

		let from = moment(this.dateFrom.val(), 'DD.MM.YYYY').hour(timeFrom.hour()).minute(timeFrom.minute());
		let to = moment(this.dateTo.val(), 'DD.MM.YYYY').hour(timeTo.hour()).minute(timeTo.minute());

		const diff = Math.ceil(to.diff(from, 'days', true))

		this.rentalLengthDays.text(diff + ' ' + Rental.inflect('day', diff))
		this.tabRentalLength.text(diff + ' ' + Rental.inflect('day', diff))
	},

	takingLocationDropdownChange() {
		const value = this.takingLocationDropdown.val();

		if (value === 'custom') {
			this.takingLocationDropdown.closest('.input').addClass('hidden');
			this.takingLocation.closest('.input').removeClass('hidden');
			this.takingLocationDescription.removeClass('hidden');
			this.takingLocation.focus();
			this.takingLocation.val('');
		} else {
			this.takingLocation.val(value);
			this.takingLocation.change();
		}
	},

	returnLocationDropdownChange() {
		let value = this.returnLocationDropdown.val();
		if (value === 'custom') {
			this.returnLocationDropdown.closest('.input').addClass('hidden');
			this.returnLocation.closest('.input').removeClass('hidden');
			this.returnLocationDescription.removeClass('hidden');
			this.returnLocation.focus();
			this.returnLocation.val('');
		} else {
			this.returnLocation.val(value);
			this.returnLocation.change();
		}
	},

    short() {
		this.dateFrom.closest('.input').removeAttr('days')
		this.dateTo.closest('.input').removeAttr('days')
		this.timeTo.closest('.input').removeClass('hidden')
		this.dateTo.closest('.input').removeClass('hidden')
		this.numberMonths.closest('.input').addClass('hidden')
		this.dateFrom.closest('.input').attr('from', moment().add(1, 'day').format('DD.MM.YYYY'))
		this.dateTo.closest('.input').attr('from', moment(this.dateFrom.val(), 'DD.MM.YYYY').add(1, 'day').format('DD.MM.YYYY'))
		this.dateTo.closest('.input').attr('to', moment(this.dateFrom.val(), 'DD.MM.YYYY').add(28, 'days').format('DD.MM.YYYY'))
		this.titleDateReturn.removeClass('hidden');
		this.titleMonthLength.addClass('hidden');
		this.numberMonths.closest('.input').addClass('hidden')
		this.rentalLengthDays.removeClass('hidden')
		this.rentalLengthMonths.addClass('hidden')
	},

    long() {
		this.dateFrom.closest('.input').removeAttr('days')
		this.dateTo.closest('.input').removeAttr('days')
		this.timeTo.closest('.input').addClass('hidden')
		this.dateTo.closest('.input').addClass('hidden')
		this.numberMonths.closest('.input').removeClass('hidden')
		this.titleDateReturn.addClass('hidden');
		this.titleMonthLength.removeClass('hidden');
		this.rentalLengthDays.addClass('hidden')
		this.rentalLengthMonths.removeClass('hidden')

		const month = parseInt(this.numberMonths.val());
		this.rentalLengthMonths.text(month + ' ' + Rental.inflect('month', month))
	},

    week() {
		this.dateFrom.closest('.input').attr('days', '5')
		this.dateTo.closest('.input').attr('days', '1')
		this.timeTo.closest('.input').removeClass('hidden')
		this.dateTo.closest('.input').removeClass('hidden')
		this.numberMonths.closest('.input').addClass('hidden')
		this.titleDateReturn.removeClass('hidden');
		this.titleMonthLength.addClass('hidden');
		this.rentalLengthDays.removeClass('hidden')
		this.rentalLengthMonths.addClass('hidden')
		this.changeNumberMonths();
    },

	changeNumberMonths() {
		const month = parseInt(this.numberMonths.val());
		const dateFrom = moment(this.dateFrom.val(), 'DD.MM.YYYY')
		const dateTo = dateFrom.add(month, 'months')
		this.dateTo.val(dateTo.format('DD.MM.YYYY'))
		this.rentalLengthMonths.text(month + ' ' + Rental.inflect('month', month))
		this.dateTo.change()
	},

    updateForm(event = null) {
        const el = event && $(event.currentTarget)
		this.dateGuard();

        el && $('[view="tabs"] [key="' + el.attr('name') + '"]').text(el.val());

        if (typeof rentalHash !== 'undefined' && rentalHash) {
            if (!this.validate()) return;
            Rental.load(null, {
                'date_from': this.dateFrom.val(),
                'time_from': this.timeFrom.val(),
                'date_to': this.dateTo.val(),
                'time_to': this.timeTo.val(),
                'rental_type': this.rentalType.val(),
                'number_months': this.numberMonths.val(),
                'taking_location': this.takingLocation.val(),
                'return_location': this.returnLocation.val(),
            })
        }
    },

	clearTaking() {
		this.takingLocation.val('');
		this.takingLocation.closest('.input').addClass('hidden');
		this.takingLocationDropdown.closest('.input').removeClass('hidden');
		this.takingLocationDescription.addClass('hidden');
		this.takingLocationDropdown.val('');
		this.takingLocationDropdown.change();
		this.takingLocationDropdown.trigger("chosen:updated");
	},

	clearReturn() {
		this.returnLocation.val('');
		this.returnLocation.closest('.input').addClass('hidden');
		this.returnLocationDropdown.closest('.input').removeClass('hidden');
		this.returnLocationDescription.addClass('hidden');
		this.returnLocationDropdown.val('');
		this.returnLocationDropdown.change();
		this.returnLocationDropdown.trigger("chosen:updated");
	},

    validate() {
        const tomorrow = moment().add(1, 'days').startOf('day')
        const dateFrom = moment(this.dateFrom.val(), 'DD.MM.YYYY')
        const dateTo = moment(this.dateTo.val(), 'DD.MM.YYYY')
        let valid = true

		// Friday, Saturday, Sunday, Monday
		const isWeek = (date) => date.day() === 5 || date.day() === 6 || date.day() === 0 || date.day() === 1;

		const rentalType = this.rentalType.val();

        if (!dateFrom.isSameOrAfter(tomorrow)) {
            this.dateFrom.closest('.input').addClass('invalid shake')
            valid = false
        } else if (rentalType === 'week' && !isWeek(dateFrom) && dateTo.diff(dateFrom) <= 4) {
			this.dateFrom.closest('.input').addClass('invalid shake')
			valid = false
		} else {
            this.dateFrom.closest('.input').removeClass('invalid shake')
        }

        const minDateTo = dateFrom.clone().add(1, 'days')

        if (!dateTo.isSameOrAfter(minDateTo)) {
            this.dateTo.closest('.input').addClass('invalid shake')
            valid = false
        }  else if (rentalType === 'week' && !isWeek(dateTo) && dateTo.diff(dateFrom) <= 4) {
			this.dateTo.closest('.input').addClass('invalid shake')
			valid = false
		} else {
			this.dateTo.closest('.input').removeClass('invalid shake')
		}

        if (this.takingLocation.val() === '') {
            this.takingLocation.closest('.input').addClass('invalid shake')
            valid = false
        } else {
            this.takingLocation.closest('.input').removeClass('invalid shake')
        }

        if (this.returnLocation.val() === '') {
            this.returnLocation.closest('.input').addClass('invalid shake')
			valid = false
        } else {
            this.returnLocation.closest('.input').removeClass('invalid shake')
        }

		if (this.takingLocationDropdown.val() === 'empty') {
			this.takingLocationDropdown.closest('.input').addClass('invalid shake')

		} else {
			this.takingLocationDropdown.closest('.input').removeClass('invalid shake')
		}

		if (this.returnLocationDropdown.val() === 'empty') {
			this.returnLocationDropdown.closest('.input').addClass('invalid shake')
		} else {
			this.returnLocationDropdown.closest('.input').removeClass('invalid shake')
		}

        setTimeout(()=>{
            this.form.find('.input').removeClass('shake invalid');
        }, 700)

		return valid;
    },

    createAsync() {
        if (!this.validate()) return;
        this.create(this.selectedVehicle).then(() => {
            window.location.href = WEB_ROOT + "/" + window.T.rental.base_url + "/" + window.T.rental.sections.vehicle.url
        }).catch(() => {
            console.error('Rental date.create() - failed');
        });
    },

    async create(vehicle, direction=null) {
        try {
            if (!this.validate()) return;
            const hash = rentalHash ? `?hash=${rentalHash}` : ''
            const url = RentalTabs.el.find('.tab.vehicle').attr('href');
            await Rental.load(url, {
                'date_from': this.dateFrom.val(),
                'time_from': this.timeFrom.val(),
                'date_to': this.dateTo.val(),
                'time_to': this.timeTo.val(),
				'rental_type': this.rentalType.val(),
				'number_months': this.numberMonths.val(),
                'taking_location': this.takingLocation.val(),
                'return_location': this.returnLocation.val(),
                ...vehicle
            }, direction);

            // console.log('Rental loaded successfully');
			if (RentalAccordion.headers) {
				RentalAccordion.headers.filter('[key="vehicle"]').removeClass('disabled');
	            history.pushState({url: url, direction: direction}, '', url + hash);
			}
        } catch (error) {
            console.error('Error loading rental:', error);
        }
    },
}

export default RentalDate;